<template>
  <modal
    ref="suppliesDeleteModal"
    class="supplies-delete-modal"
    template="question"
    title="Aviso"
    ref-name="suppliesDeleteModal"
    :icon-enabled="false"
    :close-button-enabled="false"
    first-button-text="VOLTAR"
    second-button-text="CANCELAR PEDIDO"
    @first-cta="closeModal()"
    @second-cta="handleDelete()"
  >
    <div class="modal-container">
      <div class="content">
        <p>
          Tem certeza que deseja cancelar esse pedido?
        </p>
        <div class="content-highlight">
          Pedido {{ id }}
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SupplyService from '@/api/supply'
import notify from '@/api/notification'

export default {
  name: 'SupplyDeleteModal',
  data: () => ({
    id: null
  }),
  computed: {
    ...mapGetters(['profile'])
  },
  methods: {
    ...mapActions(['supplyUpdateList']),
    openModal (id) {
      this.id = id
      this.$refs.suppliesDeleteModal.open()
    },
    closeModal () {
      this.$refs.suppliesDeleteModal.close()
    },
    submitAnalyticsEvent (action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Gestão de Insumos',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    handleDelete () {
      SupplyService
        .deleteSupplyRequest(this.id)
        .then(() => {
          this.closeModal()
          notify({
            title: 'AVISO: ',
            message: 'Solicitação cancelada com sucesso.'
          })
          this.submitAnalyticsEvent('Excluir pedido')
          if (this.$route.name === 'Gestão de Insumos') {
            this.supplyUpdateList(this.$route.query)
          } else {
            this.$router.push({name: 'Gestão de Insumos'})
          }
        })
    }
  }
}
</script>

<style lang="scss">
.supplies-delete-modal {
  .standard-modal__title {
    color: #4A4A4A;
    font-weight: bold;
    font-size: 19.2px;
    &:before {
      content: '';
      display: inline-block;
      width: 17px;
      height: 16px;
      background-image: url('/static/images/icon-alert-modal.svg');
      margin-right: 9px;
      position: relative;
      top: -3px;
    }
  }
  .modal-container {
    text-align: center;

    .content-highlight {
      padding: 15px 0;
      margin-top: 15px;
      background-color: #F5F5F5;
      font-weight: bold;
      font-size: 19.2px;
      color: #4A4A4A;
      text-align: center;
      display: block;
      width: 100%;
    }
    .content {
      text-align: left;
      color: #4A4A4A;
      font-size: 14px;
      max-width: 420px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      border-radius: 5px;
      .img-wrapper {
        width: 32px;
      }
      span {
        letter-spacing: 0;
        color: #4a4a4a;
        font-size: 14px;
        width: calc(100% - 32px);
      }
    }
    .highlight {
      background-color: #7f1a54;
      height: auto;
      padding: 12px 60px;
      font-size: 12px;
      letter-spacing: 1px;
      border-radius: 3px;
      margin: 30px auto 5px;
    }
  }
}
</style>
